import React from 'react';
import Reflux from 'reflux';
import ItemTopic from './ItemTopic';
import RcIf, {RcElse} from 'rc-if';

export default class TopicList extends Reflux.Component {
    shouldComponentUpdate (nextProps, nextState) {
        return (this.props.topics[0] !== nextProps.topics[0]);
    }
    showNoResults = () => {
        return (
          <div className='box-notfollow'>
            <img src='/images/icons/notfollow.svg' />
            <div className='txt-follow'>
              <h4>{this.props.noResultsMessage}</h4>
              <p>Explora Top5 para conocer más Tops!</p>
            </div>
          </div>
        );
    }
    render () {
        return (
          <div className='row'>
            <RcIf if={this.props.topics && this.props.topics.length > 0}>
              <ul className='rowTopicsHome'>
                {
                      this.props.topics.map((name, index) => {
                          return <ItemTopic key={name + index} topicTitle={name} />;
                      })
                }
              </ul>
              <RcElse>
                {this.showNoResults()}
              </RcElse>
            </RcIf>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sections/TopicList.js